import {
  MapMetric,
  NetworkPole,
} from '../../../../../../api/theHive/redeProto/types';
import {
  classificationColorOf,
  csatColor,
  heatColor,
  protoColors,
} from '../../theme/tokens';
import { formatCsat, formatPct } from '../../utils/format';

export const MAP_METRICS: { key: MapMetric; label: string }[] = [
  { key: 'coverage', label: 'Cobertura' },
  { key: 'sla', label: 'SLA' },
  { key: 'csat', label: 'CSAT' },
  { key: 'classification', label: 'Classificação' },
];

export const metricColor = (pole: NetworkPole, metric: MapMetric): string => {
  switch (metric) {
    case 'sla':
      return heatColor(pole.sla);
    case 'csat':
      return csatColor(pole.csat);
    case 'coverage':
      return heatColor(pole.achievement);
    case 'classification':
      return classificationColorOf(pole.classification);
    default:
      return protoColors.purple;
  }
};

export const metricValueLabel = (
  pole: NetworkPole,
  metric: MapMetric
): string => {
  switch (metric) {
    case 'sla':
      return formatPct(pole.sla);
    case 'csat':
      return formatCsat(pole.csat);
    case 'coverage':
      return formatPct(pole.achievement);
    default:
      return '';
  }
};
